import api from "../api/index.js";
import jwt_decode from "jwt-decode";

const authPlugin = {
    
    watch:  null,
    
    setup: function(Vue){
        this.watch = new Vue({
            data: function () {
                return {
                    user: null,
                    permissions: []
                };
            }
        });
    },

    processToken: function(){
        var token = localStorage.getItem("token");
        var tkdec = jwt_decode(token);
        var user = {};
        user.id = tkdec.user_id;
        user.username = tkdec.user_username;
        if(tkdec.user_subuser_id){
            user.subuser_id = tkdec.user_subuser_id;
        }else{
            user.subuser_id = 0;
        }
        this.watch.user = user;
        var permissions = [];
        if(tkdec.user_authorities){
            for(var i=0;i<tkdec.user_authorities.length;i++){
                permissions.push(tkdec.user_authorities[i].authority);
            }
        }
        this.watch.permissions = permissions;
    },

    login: function(input){
        var me = this;
        return new Promise(function(resolve, reject){
            api
            .post("/auth/token", input)
            .then(function(response) {
                var token = response.data.jwt;
                localStorage.setItem("token", token);
                me.processToken();
                resolve();
            })
            .catch(function() {
                me.watch.user = null;
                me.watch.permissions = [];
                reject();
            });
        });
    },

    remember: function(){
        var me = this;
        return new Promise(function(resolve, reject){
            var token = localStorage.getItem("token");
            api
            .get("/auth/check",{ headers: { Authorization: "Bearer " + token } })
            .then(function() {
                me.processToken();
                resolve();
            })
            .catch(function() {
                me.logout();
                reject();
            });
        });
    },
    
    user: function(){
        return this.watch.user;
    },
    
    isSubuser: function(){
        if(this.watch.user){
            return (this.watch.user.subuser_id!=0)?true:false;
        }
        return true;
    },

    isSubusername: function(username){
        if(username && this.watch.user){
            return this.watch.user.username.endsWith(username);
        }
        return false;
    },

    check: function(filter){
        if(!filter){
            return (this.watch.user)?true:false;
        }else{
            for(var i=0;i<this.watch.permissions.length;i++){
                if(this.watch.permissions[i]===filter){
                    return true;
                }
            }
        
        }
        return false;
    },
    
    logout: function(){
        this.watch.user = null;
        this.watch.permissions = [];
        localStorage.removeItem("token");
    }

};

const auth = {
    install: function(Vue){
        authPlugin.setup(Vue);
        Vue.prototype.$auth = authPlugin;
    }
};

export default auth;